import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@material-ui/core";
import { X } from "lucide-react";
import React from "react";

type Field = {
    label: string;
    value: string | number | null;
};

interface DetailDialogProps {
    open: boolean;
    onClose: () => void;
    title: string;
    fields: Field[];
}

export const DetailDialog: React.FC<DetailDialogProps> = ({
    open,
    onClose,
    title,
    fields,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    borderRadius: 12,
                    padding: 12,
                    backgroundColor: "#1e1e1e",
                    color: "white",
                    maxWidth: " 70%"
                },
            }}
        >
            <div style={{ width: "auto", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <DialogTitle style={{ fontWeight: 600, padding: 0, paddingBottom: 8 }}>
                    <div style={{ fontSize: 16 }}>{title}</div>
                </DialogTitle>
                <DialogActions style={{ width: "max-content", padding: 0 }}>
                    <X size={20} onClick={onClose} />
                </DialogActions>
            </div>
            <DialogContent dividers style={{ padding: 0 }}>
                <Box display="grid" style={{ gap: "12px" }}>
                    {fields.map((f, idx) => (
                        <Box key={idx} display="flex" style={{ gap: "12px" }}>
                            <Typography variant="body2" style={{ fontWeight: 600, fontSize: 14 }}>
                                {f.label}:
                            </Typography>
                            <Typography variant="body2" style={{ color: "#FFFFFFCC", fontSize: 14 }}>
                                {f.value ?? "—"}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </DialogContent>
        </Dialog>
    );
};